import { Theme } from '~/constants/theme/theme'

export const THEME_NS = 'theme'

export interface ThemeState {
  activeTheme: Theme
}

export default function getDefaultState(): ThemeState {
  return {
    activeTheme: Theme.LIGHT
  }
}
